<p-overlayPanel
    #opActions
    [style]="{ 'min-width': '200px', padding: '-20px', margin: '-20px' }"
>
    <ng-template pTemplate>
        <div class="conn-grid" style="margin-top: 1px">
            <div></div>
            <button
                pButton
                pRipple
                type="button"
                label="Edit"
                class="p-button-text"
                [style]="{ width: '100%' }"
                icon="pi pi-pencil"
                iconPos="right"
                (click)="optionEditClicked()"
            ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Cancel"
                class="p-button-danger p-button-text"
                [style]="{ width: '100%' }"
                icon="pi pi-trash"
                iconPos="right"
                (click)="optionEditClicked()"
            ></button>
        </div>
    </ng-template>
</p-overlayPanel>
<!-- ----++++----++++----++++----++++----++++----++++----++++----++++----++++----++++----++++----++++ -->

<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'transfer-list'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (exportCsvFn)="dt.exportCSV()"
        (locationChangedEmitter)="locationChanged($event)"
    >
    </app-report-top-filter-bar>

    <br />
    <p-table
        #dt
        [columns]="csvcols"
        styleClass="p-datatable-striped"
        id="table-001"
        [autoLayout]="true"
        [tableStyle]="{ width: 'max-content' }"
        [value]="dataList"
        responsiveLayout="scroll"
        showLoader="true"
        rowHover="true"
        selectionMode="single"
        [(selection)]="selectedRow"
        dataKey="id"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Sr#</th>
                <th>Date</th>
                <th>Transfer #</th>
                <th>Sender Store</th>
                <th>Receiving Store</th>
                <th class="text-center">Item Transferred</th>
                <th class="text-right">Shipment Cost</th>
                <th class="text-right">Total Cost ({{ '' | currencySymbol }})</th>
                <th class="text-center">Status</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="text-center">
                <td>{{ item.srNo }}</td>
                <td>{{ item.dated | date : "mediumDate" }}</td>
                <td>{{ item.transferNumber }}</td>
                <td>{{ item.warehouseFrom }}</td>
                <td>{{ item.warehouseTo }}</td>
                <td class="text-center">{{ item.totalQuantity }}</td>
                <td class="text-right">{{ item.shipping | currency | currencySpacing }}</td>
                <td class="text-right">{{ item.grandTotal | currency | currencySpacing }}</td>
                <td>
                    <p-chip
                        [label]="
                            _abd.getTransfersOutStatus(item.transfersOutStatus)
                        "
                        [styleClass]="
                            _abd.getTransfersOutClass(item.transfersOutStatus)
                        "
                    ></p-chip>
                </td>
                <td class="text-center">
                    <button
                        pButton
                        pRipple
                        icon="pi pi-angle-down"
                        iconPos="right"
                        type="button"
                        label="Actions"
                        class="n-action-button"
                        (click)="opActions.toggle($event)"
                        (click)="actionButtonClicked(item)"
                        [disabled]="
                            doEnableActionButton(item.transfersOutStatus)
                        "
                    ></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" style="text-align: center">
            <tr>
                <td colspan="10" style="text-align: center">
                    There is no data to show.
                </td>
            </tr>
        </ng-template>
    </p-table>

    <br />
    <p-paginator
        #p
        [first]="first"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Records: {first} of {last}, Total Records: {totalRecords}"
    >
    </p-paginator>
</div>
